import React, { FC, SVGProps } from 'react'
const ArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={9} height={6} fill="none" {...props}>
    <path fill="#11245A" d="m8.5 1.273-.94-.94L4.5 3.387 1.44.333l-.94.94 4 4 4-4Z" />
  </svg>
)
export default ArrowIcon
